import { ProductFeatureWithAccessedDTO } from "../domain/models/dto/ProductFeatureDTO";
import { RolesCollection } from "../domain/models/Role";
import { RoleService } from "../domain/services/RoleService";
import { BaseServiceImpl } from "./BaseServiceImpl";

export class RoleServiceImpl extends BaseServiceImpl implements RoleService {
    static _instance: RoleService;
    private readonly rolesEndpoint = "/api/v1/roles"

    private constructor() {
        super();
    }

    static getInstance(): RoleService {
        if (!RoleServiceImpl._instance) {
            RoleServiceImpl._instance = new RoleServiceImpl();
        }
        return RoleServiceImpl._instance;
    }

    async getAllRoles(
        currentPage: number,
        currentLimit: number,
        filtersDTO: { name?: string } = {}
    ): Promise<RolesCollection> {
        try {
            let url = `${this.rolesEndpoint}?limit=${currentLimit}&page=${currentPage}`;
            Object.entries(filtersDTO).forEach(([key, value]) => {
                if (key && value !== null && value !== undefined) {
                    url += `&${key}=${value}`;
                }
            });

            return await this.get<RolesCollection>(url);
        } catch (err) {
            console.log("Error in RoleServiceImpl.getAllRoles");
            console.log(err);
        }
    }

    async getRolesFeatures(
        roleId: number
    ): Promise<ProductFeatureWithAccessedDTO[]> {
        try {
            const url = `${this.rolesEndpoint}/${roleId}/product-features`;
            return await this.get(url);
        } catch (err) {
            console.log("Error in RoleServiceImpl.getRolesFeatures");
            console.log(err);
        }
    }

    async patchRoleFeatures(
        roleId: number,
        roleProductFeatures: ProductFeatureWithAccessedDTO[]
    ): Promise<any> {
        try {
            const url = `${this.rolesEndpoint}/${roleId}/product-features`;
            return await this.patch(url, { roleProductFeatures });
        } catch (err) {
            console.log("Error in RoleServiceImpl.patchRoleFeatures");
            console.log(err);
        }
    }
}

export function roleServiceFactory(): RoleService {
    return RoleServiceImpl.getInstance();
}
